import { AddressDeliveryType } from "../../../models/transportation/enums/addressDeliveryType";
import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class CreateAddress {
    
    public name             : string = '';

    public addressLine1     : string = '';
    
    public addressLine2     : string | null = null;
    
    public city             : string = '';
    
    public stateProvince    : string = '';
    
    public postalCode       : string = '';
    
    public country          : string | null = null;
    
    public latitude         : number = 0;
    
    public longitude        : number = 0;
    
    public timeZoneId       : string | null = null;
}

export class DeliveryAddressCreate {
    
    public force: boolean = false;

    public name: string = '';

    public customerId : string = '';

    public phoneNumber: string = '';

    @JsonProperty({ toClass : CreateAddress })
    public address : CreateAddress = new CreateAddress();

    public unloadRate : number|undefined = undefined;

    public isJobSite: boolean = false;
    
    public contactEmailBusiness: string | null = null;
    
    public contactNameBusiness: string | null = null;
    
    public contactPhoneNumberBusiness: string | null = null;
    
    public contactEmailSite: string | null = null;
    
    public contactNameSite: string | null = null;
    
    public contactPhoneNumberSite: string | null = null;

    public note: string | null = null;

    public deliveryTypes: AddressDeliveryType[] = [];
    
    @ValidateProperty({ minChildren: 1 })
    public deliveryHours: DeliveryHourCreate[] = [];

    public shipToAddressId: number | null = null;
}

export class DeliveryHourCreate {

    public weekDays: number;

    public startTime: string = '';

    public endTime?: string = '';
}

export enum AddressCreateStatus {
    Unknown = 0,
    Created = 1,
    NotCreatedGoogleHasSuggestion = 2,
    NotCreatedGoogleNotFound = 3,
    CannotCreate = 4
}

export class DeliveryAddressCreateResponse {
    
    public shipToAddressId: number | null = null;

    @JsonProperty({ toClass: CreateAddress })
    public suggestedAddress: CreateAddress = new CreateAddress();

    public status: AddressCreateStatus = AddressCreateStatus.Unknown;

    public errorMessage: string | null = null;
}
